/* eslint-disable react/prop-types */
// Dependencies
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';

// Hook
import useMap from '../../hooks/useMap';

// images
import marker from '../../../sass/images/icons/pin-vehiculo.svg';

function VehiclesMapDashboard(props) {
  const { google, plate } = props;

  const mapStyles = {
    position: 'relative',
    width: 'auto',
    height: '400px',
  };

  const {
    markers,
    onMarkerClick,
    onInfoWindowClose,
    latitud,
    longitud,
    activeMarker,
    selectedPlace,
    showingInfoWindow,
    getMap,
  } = useMap(plate);

  // Memoriza el centro del mapa para evitar recreación innecesaria
  const mapCenter = useMemo(
    () => ({
      lat: latitud,
      lng: longitud,
    }),
    [latitud, longitud]
  );

  return (
    <div className="block-map">
      <Map
        google={google}
        zoom={15}
        center={mapCenter}
        onReady={getMap}
        style={mapStyles}
      >
        {markers &&
          markers.map((coords) => (
            <Marker
              key={coords.id}
              icon={{
                url: marker,
                anchor: new google.maps.Point(17, 46),
                scaledSize: new google.maps.Size(50, 59),
              }}
              position={{ lat: coords.lat, lng: coords.lng }}
              onClick={onMarkerClick}
              placeId={coords.id}
              driver={coords.driver.driver}
              placa={coords.placa}
              lat={coords.lat}
              lng={coords.lng}
            />
          ))}

        <InfoWindow
          marker={activeMarker}
          onClose={onInfoWindowClose}
          visible={showingInfoWindow}
          options={{
            pixelOffset: new google.maps.Size(0, -40),
          }}
        >
          <div style={{ backgroundColor: '#0F1E2A', color: '#ffffff', padding: '8px', borderRadius: '4px' }}>
            <b>Conductor</b>
            <p>{selectedPlace.driver}</p>
            <b>Placa</b>
            <p>{selectedPlace.placa}</p>
            <b>Ubicación</b>
            <p>
              {selectedPlace.lat}, {selectedPlace.lng}
            </p>
          </div>
        </InfoWindow>
      </Map>
    </div>
  );
}

VehiclesMapDashboard.propTypes = {
  google: PropTypes.shape({ maps: PropTypes.object }).isRequired,
};

export default GoogleApiWrapper({
  apiKey: 'AIzaSyAOyqbslXqz9nQ1JvaWO-ihiQOSsWDi3oE',
})(VehiclesMapDashboard);
